export const PAID_STATUS = {
  PENDING: {
    status_code: 'PENDING',
    description: 'pending',
  },
  APPROVE: {
    status_code: 'APPROVE',
    description: 'approve',
  },
  SUCCESS: {
    status_code: 'SUCCESS',
    description: 'success',
  },
  REJECT: {
    status_code: 'REJECT',
    description: 'reject',
  },
  PREPARE: {
    status_code: 'PREPARE',
    description: 'prepare',
  },
  CANCEL: {
    status_code: 'CANCEL',
    description: 'cancel',
  },
  PREAPPROVE: {
    status_code: 'PREAPPROVE',
    description: 'pree-approve',
  },
};
export default PAID_STATUS;
